import axios from './axios';

export const createTransaction = async (data) => {
  const res = await axios({
    method: 'POST',
    url: '/api/transaction/create',
    data,
  });

  return res.data;
};

export const getTransactions = async () => {
  const res = await axios({
    method: 'GET',
    url: '/api/transaction/all',
  });

  return res.data;
};

export const getAllTransactions = async (userType) => {
  if (userType !== 'admin') return;

  const res = await axios({
    method: 'GET',
    url: '/api/transaction/transactions',
  });

  return res.data;
};

export const updateTransaction = async ({ userType, userId, data }) => {
  if (userType !== 'admin') return;

  const res = await axios({
    method: 'PUT',
    url: `/api/transaction/${userId}`,
    data,
  });

  return res.data;
};
